import { Scale } from "@pdfking/math"

import type { CalendarArea, CalendarBoxes } from "#internal"

import { Slice } from "../layout/Slice"
import { Area } from "./Area"

/** The whole year on a page: the year at its head over its months, small,
 * four across a landscape page and three any other, the contact at its
 * foot. */
export const CalendarYearAreas = ({
  body,
  contact,
  gap,
  page,
  short,
  year,
}: CalendarBoxes): CalendarArea[] => {
  const [head, rest] = Slice.top(body, Scale(short, 0.08), gap)
  return [
    Area.year(head, year),
    ...Area.months(rest, year, page.width > page.height ? 4 : 3, gap),
    Area.footer(contact),
  ]
}
